import Box from '@mui/material/Box/Box';
import Stack from "@mui/material/Stack/Stack";
import Button from "@mui/material/Button/Button";
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import { Dayjs } from 'dayjs';
import { UseDateFieldProps } from '@mui/x-date-pickers/DateField';
import {
  BaseSingleInputFieldProps,
  DateValidationError,
  FieldSection,
} from '@mui/x-date-pickers/models';
import React, { useEffect, useState } from 'react';
import { datepickerStyle } from '../../styles/common/daterangepicker';

interface ButtonFieldProps
  extends UseDateFieldProps<Dayjs>,
    BaseSingleInputFieldProps<
      Dayjs | null,
      Dayjs,
      FieldSection,
      DateValidationError
    > {
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

function ButtonField(props: ButtonFieldProps) {
  const {
    setOpen,
    label,
    id,
    disabled,
    InputProps: { ref } = {},
    inputProps: { 'aria-label': ariaLabel } = {},
  } = props;

  return (
    <Button
      sx={datepickerStyle.contentButton}
      startIcon={<CalendarMonthOutlinedIcon/>}
      variant="outlined"
      color="secondary"
      size="medium"
      id={id}
      disabled={disabled}
      ref={ref}
      aria-label={ariaLabel}
      onClick={() => setOpen?.((prev) => !prev)}
    >
      {label ?? 'Pick a date'}
    </Button>
  );
}

function ButtonStartDatePicker(
  props: Omit<DatePickerProps<Dayjs>, 'open' | 'onOpen' | 'onClose'>,
) {
  const [open, setOpen] = useState(false);
  const { slots, ...otherProps } = props;

  return (
    <DatePicker
      slots={{ field: ButtonField, ...slots }} {...otherProps}
      slotProps={{ 
        field: { setOpen } as any,
        actionBar: {
          actions: ['clear'],
        },
      }}
      {...props}
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
    />
  );
}

function ButtonEndDatePicker(
  props: Omit<DatePickerProps<Dayjs>, 'open' | 'onOpen' | 'onClose'>,
) {
  const [open, setOpen] = useState(false);
  const { slots, ...otherProps } = props;

  return (
    <DatePicker
      // minDate={}
      slots={{ field: ButtonField, ...slots }} {...otherProps}
      slotProps={{ 
        field: { setOpen } as any,
        actionBar: {
          actions: ['clear'],
        },
      }}
      {...props}
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
    />
  );
}

export function DateRangePicker(props: { startDate: (startDate: Dayjs | null) => void; endDate: (endDate: Dayjs | null) => void; }){
  const [startDateValue, setStartDateValue] = useState<Dayjs | null>(null);
  const [EndDatevalue, setEndDateValue] = useState<Dayjs | null>(null);

  return (
    <Box sx={datepickerStyle.contentBox}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack spacing={1} sx={datepickerStyle.contentBoxStack}>
          <ButtonStartDatePicker
            maxDate={EndDatevalue !== null ? EndDatevalue : undefined}
            label={`${
              startDateValue == null ? 'Start Date' : startDateValue.format('MM/DD/YYYY')
            }`}
            value={startDateValue}
            onChange={(newValue) => {
              setStartDateValue(newValue)
              props?.startDate(newValue)
            }}
          />
        </Stack>
      </LocalizationProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack spacing={1} 
          // sx={datepickerStyle.contentBoxStack}
        >
          <ButtonEndDatePicker
            minDate={startDateValue !== null ? startDateValue : undefined}
            label={`${
              EndDatevalue == null ? 'End Date' : EndDatevalue.format('MM/DD/YYYY')
            }`}
            value={EndDatevalue}
            onChange={(newValue) => {
              setEndDateValue(newValue)
              props?.endDate(newValue)
            }}
          />
        </Stack>
      </LocalizationProvider>
      {/* <h1>{startDateValue ? startDateValue.format('YYYY-MM-DD') : 'No date selected'}</h1> */}
    </Box>
  );
};
